// Transitional English translations for legacy Fleet UI.
//
// These entries intentionally contain only copy that is still hard-coded in the
// Fleet screens/components. Shared translations already present in the root
// legacy catalog are not repeated here. New UI should use semantic i18n keys.

export const legacyEnglishFleet = Object.freeze({
  // Fleet lists, access and empty states
  'Eroare la ștergerea remorcii': 'Error deleting trailer',
  'Eroare la ștergerea camionului': 'Error deleting truck',
  'Necesită rol de Fleet Manager': 'Fleet Manager role required',
  'remorcă': 'trailer',
  'remorci': 'trailers',
  'camion': 'truck',
  'camioane': 'trucks',
  'dubă': 'van',
  'dube': 'vans',
  'autoturism': 'passenger car',
  'autoturisme': 'passenger cars',
  'găsit': 'found',
  'găsită': 'found',
  'găsite': 'found',
  'în flotă': 'in fleet',
  'Adaugă camion': 'Add truck',
  'Adaugă Camion': 'Add Truck',
  'Adaugă remorcă': 'Add trailer',
  'Adaugă Remorcă': 'Add Trailer',
  'Niciun rezultat': 'No results',
  'Nu există remorci': 'No trailers',
  'Pregătim lista de camioane.': 'Preparing the truck list.',
  'Pregătim lista de remorci.': 'Preparing the trailer list.',
  'Camionul a fost șters cu succes.': 'Truck deleted successfully.',
  'Remorca a fost ștearsă cu succes.': 'Trailer deleted successfully.',
  'Nu s-a putut șterge. Încearcă din nou mai târziu.': 'Could not delete the truck. Please try again later.',
  'Nu s-a putut șterge remorca. Încearcă din nou mai târziu.': 'Could not delete the trailer. Please try again later.',
  'Camionul nu a putut fi încărcat': 'The truck could not be loaded',
  'Camionul nu a putut fi găsit': 'Truck not found',
  'Camion #': 'Truck #',
  'Înapoi la camioane': 'Back to trucks',
  'Camionul nu a putut fi găsit.': 'Truck not found.',
  'Ești sigur că dorești să ștergi camionul': 'Are you sure you want to delete the truck',
  'Ești sigur că dorești să ștergi remorca': 'Are you sure you want to delete the trailer',
  'Nu s-a găsit niciun camion pentru „': 'No truck was found for “',
  'Nu s-a găsit nicio remorcă pentru „': 'No trailer was found for “',
  'Nu s-a găsit niciun camion cu numărul de înmatriculare "': 'No truck was found with registration number "',
  'Nu s-a găsit nicio remorcă cu numărul de înmatriculare "': 'No trailer was found with registration number "',

  // Vehicle and document summaries
  'Vehicul': 'Vehicle',
  'Vehicule': 'Vehicles',
  'Categorie': 'Category',
  'Categorie:': 'Category:',
  'Categorie *': 'Category *',
  'Descriere': 'Description',
  'Expirat': 'Expired',
  'Fără expirare': 'No expiry date',
  'Fără dată de expirare': 'No expiry date',
  'Fără status': 'No status',
  'Fără categorie': 'Uncategorised',
  'Necategorizat': 'Uncategorised',
  'Document fără titlu': 'Untitled document',
  'Nume document': 'Document name',
  'Nume document *': 'Document name *',
  'Document nou': 'New document',
  'Documente existente': 'Existing documents',
  'Detalii suplimentare despre document': 'Additional document details',
  'Alege data': 'Choose date',
  'Alege fișierul': 'Choose file',
  'Alege fisier optional': 'Choose an optional file',
  'Înlocuiește fișierul (opțional)': 'Replace file (optional)',
  'Incarca document nou': 'Upload new document',
  'Data expirarii': 'Expiry date',
  'Descriere (optional)': 'Description (optional)',
  'Nu exista documente incarcate': 'No documents uploaded',
  'Număr neînregistrat': 'Registration number unavailable',
  'VIN neînregistrat': 'VIN unavailable',
  'Valabilitate și expirări': 'Validity and expiry dates',
  'Toate actele vehiculelor, ordonate după urgență.': 'All vehicle documents, ordered by urgency.',
  'Rezumat documente': 'Document summary',
  'Rezumat documente vehicule': 'Vehicle document summary',
  'Necesită verificare': 'Requires review',
  'Necesită actualizare': 'Requires update',
  'Camioane, remorci, mașini și dube': 'Trucks, trailers, passenger cars and vans',
  'Caută după număr, VIN, document sau categorie...': 'Search by registration number, VIN, document or category...',
  'Documentele nu au putut fi încărcate': 'Documents could not be loaded',
  'Schimbă filtrul sau termenul de căutare.': 'Change the filter or search term.',
  'Gestionează documentele': 'Manage documents',
  'Deschide fișierul': 'Open file',
  'Eroare la încărcarea documentelor remorcilor': 'Error loading trailer documents',
  'Sumar documente remorci': 'Trailer document summary',
  'Documente remorci': 'Trailer documents',
  'Nu există documente încărcate pentru remorci.': 'No trailer documents have been uploaded.',
  'Eroare la încărcarea documentelor camioanelor': 'Error loading truck documents',
  'Sumar documente camioane': 'Truck document summary',
  'Documente camioane': 'Truck documents',
  'Nu există documente încărcate pentru camioane.': 'No truck documents have been uploaded.',
  'Eroare la încărcarea documentului': 'Error loading document',
  'Eroare la ștergerea documentului': 'Error deleting document',
  'Nu am putut încărca documentele vehiculului.': 'Could not load the vehicle documents.',
  'Nu am putut încărca documentele flotei. Încearcă din nou.': 'Could not load the fleet documents. Please try again.',
  'Serverul nu a putut procesa modificarea documentului. Dacă ai schimbat categoria, verifică dacă acea categorie are deja un document activ.': 'The server could not process the document change. If you changed the category, check whether it already has an active document.',
  'Ștergi documentul "': 'Delete document "',
  '"? Dacă este valid, următorul document devine automat activ.': '"? If it is valid, the next document will automatically become active.',
  'Sigur vrei să ștergi documentul "': 'Are you sure you want to delete document "',
  'Sigur vrei sa stergi documentul "': 'Are you sure you want to delete document "',
  'Documentul a fost șters.': 'Document deleted.',
  'Nu am putut șterge documentul.': 'Could not delete the document.',
  'Data expirării nu poate fi înaintea datei emiterii.': 'The expiry date cannot be before the issue date.',
  'Nu s-a putut efectua editarea. Categoria "': 'The document could not be updated. Category "',
  'Documentul a fost actualizat.': 'Document updated.',
  'Nu s-a putut efectua editarea.': 'The document could not be updated.',
  'Selectează fișierul documentului.': 'Select the document file.',
  'Documentul a fost încărcat cu succes.': 'Document uploaded successfully.',
  'Nu am putut încărca documentul.': 'Could not upload the document.',

  // Driver documents, cards and monthly per diem
  'Ati verificat date generate de ai?': 'Have you reviewed the AI-generated data?',
  'Pentru': 'For',
  'Transport frigorific': 'Refrigerated transport',
  'Rol': 'Role',
  'Vezi diurne lunare': 'View monthly per diem',
  'Documente -': 'Documents –',
  'Stergi': 'Delete',
  'Diurne lunare ·': 'Monthly per diem ·',
  'Conversie': 'Conversion',
  'Bonuri -': 'Receipts –',

  // Driver leave management and reports
  'Respinge cererea': 'Reject request',
  'Motiv respingere': 'Rejection reason',
  'Creat pe': 'Created on',
  'Motiv': 'Reason',
  'Aproba': 'Approve',
  'Anterior': 'Previous',
  'Tipul Raportului': 'Report Type',
  'Raport Lunar': 'Monthly Report',
  'Raport Anual': 'Annual Report',
  'Anul': 'Year',
  'Statistici complete pentru anul selectat': 'Complete statistics for the selected year',
  'Parolele nu coincid': 'Passwords do not match',

  // Driver observations and trip sheets
  'Descriere *': 'Description *',
  'Autovehicul': 'Vehicle',
  'Traseele zilei': "Today's routes",

  // Vehicle document categories
  'Licență transport': 'Transport licence',
  'Certificat de conformitate': 'Certificate of conformity',
  'EC Certificat de conformitate': 'EC certificate of conformity',
  'Inspecții tehnice periodice': 'Periodic roadworthiness inspections',
  'Copie conformă': 'Certified copy',
  'Procedură de instalare': 'Installation procedure',
  'Certificat de înmatriculare': 'Vehicle registration certificate',
  'Atestat vehicul': 'Vehicle certification',
  'Certificat înmatriculare': 'Vehicle registration certificate',
  'Autorizație transport': 'Transport authorisation',
  'Certificate limitator viteză': 'Speed limiter certificates',
  'ITP (Inspecție Tehnică Periodică)': 'Periodic roadworthiness inspection (ITP)',
  'RAR (Registrul Auto Român)': 'Romanian Automotive Register (RAR)',
  'Alte documente vehicul': 'Other vehicle documents',
  'Altă categorie': 'Other category',

  // Document upload and editing
  'Tip de fișier neacceptat. Vă rugăm să încărcați fișiere PDF, DOC, DOCX, JPG sau PNG.': 'Unsupported file type. Please upload a PDF, DOC, DOCX, JPG or PNG file.',
  'Vă rugăm să introduceți numele categoriei personalizate': 'Please enter the custom category name',
  'Data emiterii trebuie să fie în formatul AAAA-LL-ZZ': 'The issue date must use the YYYY-MM-DD format',
  'Data de sfârșit a valabilității trebuie să fie în formatul AAAA-LL-ZZ': 'The validity end date must use the YYYY-MM-DD format',
  'Documentul Word va fi încărcat. Analiza AI automată este disponibilă pentru PDF, JPG și PNG.': 'The Word document will be uploaded. Automatic AI analysis is available for PDF, JPG and PNG files.',
  'Datele extrase cu AI au completat automat câmpurile disponibile. Verifică valorile înainte de salvare.': 'AI-extracted data has automatically populated the available fields. Review the values before saving.',
  'Nu am putut extrage automat datele din document. Poți completa manual câmpurile și salva documentul.': 'Data could not be extracted automatically. You can complete the fields manually and save the document.',
  'Documentul a fost adăugat cu succes!': 'Document added successfully!',
  'Fișier document (opțional)': 'Document file (optional)',
  'Fișier document remorcă (opțional)': 'Trailer document file (optional)',
  'Adaugă document remorcă': 'Add trailer document',
  'Eliberează pentru a încărca': 'Drop to upload',
  'Atașează fișier opțional': 'Attach an optional file',
  'Eliberează fișierul aici': 'Drop the file here',
  'Apasă pentru a selecta sau trage fișierul aici': 'Click to select a file or drag it here',
  '✕ Închide': '✕ Close',
  'EDITARE DOCUMENT VEHICUL': 'EDIT VEHICLE DOCUMENT',
  'Fișier Actual': 'Current File',
  'Păstrează fișierul actual sau selectează unul nou': 'Keep the current file or select a new one',
  'Clicește pentru a schimba': 'Click to change',
  'Clicește pentru a selecta': 'Click to select',
  'Categorie Document': 'Document Category',
  'Alege tipul documentului': 'Choose the document type',
  'Categoria selectată': 'Selected category',
  'Alege': 'Choose',
  'Alege statusul documentului': 'Choose document status',
  'Selectează statusul': 'Select status',
  'Data selectată': 'Selected date',
  'Actualizează documentul vehiculului': 'Update vehicle document',
  'Introduceți un titlu pentru document': 'Enter a document title',
  'Selectați o categorie pentru document': 'Select a document category',
  'Sesiune invalidă. Reîncercați după autentificare.': 'Invalid session. Sign in and try again.',
  'Nu s-a putut actualiza documentul': 'The document could not be updated',
  'Documentul remorcii a fost actualizat cu succes.': 'Trailer document updated successfully.',
  'A apărut o eroare la actualizarea documentului.': 'An error occurred while updating the document.',
  'Alege fișier': 'Choose file',
  'Fișier nou:': 'New file:',
  'Sigur vrei să ștergi acest document?': 'Are you sure you want to delete this document?',
  'Deschide documentul': 'Open document',
  'Descarcă document': 'Download document',
  'Descarcă documentul': 'Download document',
  'Vezi': 'View',

  // Expired-document page
  'Nu am putut încărca detaliile camionului.': 'Could not load the truck details.',
  'Nu am putut încărca documentele. Încearcă din nou.': 'Could not load the documents. Please try again.',
  'Expirat de': 'Expired for',
  'Expiră în': 'Expires in',
  'Selectează un camion pentru a vedea documentele care expiră.': 'Select a truck to view its expiring documents.',
  'Înapoi la Camioane': 'Back to Trucks',
  'Caută document...': 'Search documents...',
  'Toate documentele': 'All documents',
  'Sortare după dată expirare': 'Sort by expiry date',
  'Sortare după nume': 'Sort by name',
  'Nu s-au găsit documente care să corespundă criteriilor': 'No documents match the selected criteria',
  'Nu există documente expirate sau care expiră în curând': 'There are no expired or soon-to-expire documents',
  'Data Expirare': 'Expiry Date',
  'Expiră la:': 'Expires on:',
  'Descarcă Document': 'Download Document',
  'Înapoi la Flota': 'Back to Fleet',
  'document expirat': 'expired document',
  'documente expirate': 'expired documents',
  'zi': 'day',
  'pentru acest vehicul': 'for this vehicle',
  'Toate documentele sunt la zi!': 'All documents are up to date!',
  'Nu există documente expirate pentru acest vehicul.': 'This vehicle has no expired documents.',
  'Reîncarcă Documente': 'Reload Documents',
  'Anul fabricației:': 'Year of manufacture:',

  // Personal-document labels used by the shared legacy document editor
  'Certificat medical': 'Medical certificate',
  'Fișa postului': 'Job description',
  'Contract individual de muncă': 'Individual employment contract',
  'Adeverință angajator': 'Employer certificate',
  'Cereri concediu': 'Leave requests',
  'Alte documente': 'Other documents',
  'Documentul a fost actualizat cu succes': 'Document updated successfully',
  'Actualizează documentul': 'Update document',

  // Service interventions
  'Selectați data': 'Select a date',
  'Eroare la încărcarea vehiculelor': 'Error loading vehicles',
  'Eroare la încărcarea intervenției': 'Error loading intervention',
  'Eroare la încărcarea intervențiilor': 'Error loading interventions',
  'Eroare la încărcarea intervențiilor programate': 'Error loading scheduled interventions',
  'Selectați un camion': 'Select a truck',
  'Selectați o remorcă': 'Select a trailer',
  'Selectați o dubă': 'Select a van',
  'Data intrării în service este obligatorie': 'The service start date is required',
  'Costul pieselor trebuie să fie un număr': 'The parts cost must be a number',
  'Costul manoperei trebuie să fie un număr': 'The labour cost must be a number',
  'Alte costuri trebuie să fie un număr': 'Other costs must be a number',
  'Kilometrajul trebuie să fie un număr': 'The mileage must be a number',
  'Kilometrajul de ieșire trebuie să fie mai mare decât cel de intrare': 'The exit mileage must be greater than the entry mileage',
  'Data de ieșire trebuie să fie după data de intrare': 'The exit date must be after the entry date',
  'Vă rugăm să corectați erorile din formular': 'Please correct the errors in the form',
  'Intervenția a fost actualizată cu succes': 'Intervention updated successfully',
  'Intervenția a fost creată cu succes': 'Intervention created successfully',
  'Intervenția a fost ștearsă cu succes': 'Intervention deleted successfully',
  'Vehiculul selectat nu este disponibil pentru pornirea service-ului.': 'The selected vehicle is not available to start service.',
  'Completează câmpurile obligatorii pentru a crea intervenția.': 'Complete the required fields to create the intervention.',
  'Selectează camionul, remorca sau duba pentru care adaugi intervenția': 'Select the truck, trailer or van for this intervention',
  'Alege tipul intervenției și locația service-ului': 'Choose the intervention type and service location',
  'Introdu data și ora intrării în service': 'Enter the service start date and time',
  'Adaugă descrierea defectului': 'Add a description of the fault',
  'Eroare la salvarea intervenției': 'Error saving intervention',
  'Eroare la ștergerea intervenției': 'Error deleting intervention',
  'Eroare la actualizarea statusului': 'Error updating status',
  'Statusul a fost actualizat cu succes': 'Status updated successfully',
  'Editare intervenție': 'Edit intervention',
  'Factură și transport asociat': 'Invoice and linked transport',
  'Selectați transportul asociat': 'Select the linked transport',
  'Selectare vehicul': 'Select vehicle',
  'Selectați tipul': 'Select type',
  'Selectați status': 'Select status',
  'Selectați locația': 'Select location',
  'Nume service extern': 'External service provider name',
  'Data intrare service': 'Service start date',
  'Data ieșire service': 'Service end date',
  'Descriere defect': 'Fault description',
  'Descriere Defect:': 'Fault Description:',
  'Nume mecanic': 'Mechanic name',
  'Costuri': 'Costs',
  'Cost piese (': 'Parts cost (',
  'Alte costuri (': 'Other costs (',
  'Alte costuri:': 'Other costs:',
  'Piese:': 'Parts:',
  'Creat la:': 'Created on:',
  'Sigur doriți să ștergeți această intervenție?': 'Are you sure you want to delete this intervention?',
  'Sigur doriți să ștergeți această intervenție? Această acțiune nu poate fi anulată.': 'Are you sure you want to delete this intervention? This action cannot be undone.',
  'Vă rugăm să selectați un fișier și să introduceți un titlu': 'Please select a file and enter a title',
  'Documentul a fost încărcat cu succes': 'Document uploaded successfully',
  'Sigur doriți să ștergeți acest document?': 'Are you sure you want to delete this document?',
  'Documentul a fost șters cu succes': 'Document deleted successfully',
  'Vezi Istoric Vehicul': 'View Vehicle History',
  'Sumar Costuri': 'Cost Summary',
  'Raport': 'Report',
  'Browser a blocat fereastra de tipărire. Permite pop-up și încearcă din nou.': 'Your browser blocked the print window. Allow pop-ups and try again.',
  'Raport Intervenții': 'Intervention Report',
  'Perioadă:': 'Period:',
  'Total intervenții:': 'Total interventions:',
  'Top vehicule după cost': 'Top vehicles by cost',
  'Nr. intervenții': 'No. of interventions',
  'Intrare': 'Entry',
  'Raportul s-a deschis în format de tipărire (poți salva ca PDF).': 'The report opened in print view (you can save it as a PDF).',
  'Raportul PDF a fost descărcat în Downloads.': 'The PDF report was downloaded to your Downloads folder.',
  'Eroare la descărcarea raportului': 'Error downloading report',
  'Adaugă o nouă intervenție în sistem.': 'Add a new intervention to the system.',
  'Vezi intervențiile programate.': 'View scheduled interventions.',
  'Toate Statusurile': 'All Statuses',
  'Toate dubele': 'All vans',
  'Planificare Service': 'Service Planning',
  'Astăzi': 'Today',
  'Vezi detalii': 'View details',
  'Eroare la încărcarea datelor vehiculului': 'Error loading vehicle data',
  'Eroare la descărcarea istoricului': 'Error downloading history',
  'Vehicul negăsit': 'Vehicle not found',
  'Istoric Service:': 'Service History:',
  'Intervenție Nouă': 'New Intervention',
  'Total Intervenții': 'Total Interventions',
  'Durată Medie': 'Average Duration',
  'Zile între Service': 'Days Between Services',
  'Toți Anii': 'All Years',
  'intervenții': 'interventions',
  'Cronologie Intervenții': 'Intervention Timeline',
  'Nu există intervenții pentru criteriile selectate': 'No interventions match the selected criteria',
  'Defalcare Costuri pe Tip': 'Cost Breakdown by Type',

  // Passenger cars and vans
  'Autoturism': 'Passenger Car',
  'Autoturisme': 'Passenger Cars',
  'Dube': 'Vans',
  'Altul': 'Other',
  'În service': 'In service',
  'Manuală': 'Manual',
  'Automată': 'Automatic',
  'Semi-automată': 'Semi-automatic',
  'Dubă închisă': 'Panel van',
  'Carosată': 'Box van',
  'Prelată': 'Curtain-side van',
  'Platformă': 'Flatbed',
  'Microbuz': 'Minibus',
  'Alt tip': 'Other type',
  'Instalație frigorifică': 'Refrigeration unit',
  'Lift hidraulic': 'Tail lift',
  'Echipare ADR': 'ADR equipment',
  'Cârlig de remorcare': 'Tow bar',
  'Rafturi': 'Shelving',
  'Alt echipament': 'Other equipment',
  'Nespecificat': 'Not specified',
  'Număr A–Z': 'Registration number A–Z',
  'Număr Z–A': 'Registration number Z–A',
  'Marcă A–Z': 'Make A–Z',
  'Caută după număr, VIN, marcă sau model...': 'Search by registration number, VIN, make or model...',
  'Toți combustibilii': 'All fuel types',
  'Toate tipurile': 'All types',
  'Utilizare': 'Use',
  'Se actualizează lista…': 'Updating the list…',
  'Nu există': 'No',
  'Schimbă termenul de căutare sau resetează filtrele pentru a vedea mai multe rezultate.': 'Change the search term or reset the filters to see more results.',
  'Adaugă primul': 'Add the first',
  'pentru a începe evidența.': 'to start your records.',
  'Nu există încă vehicule înregistrate în această categorie.': 'There are no vehicles registered in this category yet.',
  'Șterge filtrele': 'Clear filters',
  'Se șterge…': 'Deleting…',
  'Da, șterge': 'Yes, delete',
  'Număr de locuri': 'Number of seats',
  'Tip dubă': 'Van type',
  'Masă maximă': 'Maximum mass',
  'Masă maximă autorizată': 'Maximum authorised mass',
  'Dimensiuni marfă': 'Cargo dimensions',
  'Dimensiuni spațiu marfă': 'Cargo space dimensions',
  'Dimensiuni spațiu de marfă': 'Cargo space dimensions',
  'Kilometraj actualizat la': 'Mileage updated on',
  'Șterge vehiculul': 'Delete vehicle',
  'Editează informațiile': 'Edit information',
  'Marcă neînregistrată': 'Make unavailable',
  'An neînregistrat': 'Year unavailable',
  'Introdu numărul de înmatriculare.': 'Enter the registration number.',
  'Introdu anul fabricației.': 'Enter the year of manufacture.',
  'Selectează tipul de combustibil.': 'Select the fuel type.',
  'Anul trebuie să fie între 1900 și': 'The year must be between 1900 and',
  'Kilometrajul trebuie să fie mai mare decât 0.': 'The mileage must be greater than 0.',
  'Introdu numărul de locuri.': 'Enter the number of seats.',
  'Numărul de locuri trebuie să fie mai mare decât 0.': 'The number of seats must be greater than 0.',
  'Valoarea trebuie să fie mai mare decât 0.': 'The value must be greater than 0.',
  'Introdu masa maximă autorizată.': 'Enter the maximum authorised mass.',
  'Introdu volumul spațiului de marfă.': 'Enter the cargo space volume.',
  'Introdu lungimea spațiului de marfă.': 'Enter the cargo space length.',
  'Introdu lățimea spațiului de marfă.': 'Enter the cargo space width.',
  'Introdu înălțimea spațiului de marfă.': 'Enter the cargo space height.',
  'Selectează tipul dubei.': 'Select the van type.',
  'Sarcina utilă nu poate depăși masa maximă autorizată.': 'The payload cannot exceed the maximum authorised mass.',
  'Nu ai permisiunea necesară pentru a modifica vehiculele.': 'You do not have permission to modify vehicles.',
  'Verifică informațiile marcate înainte de salvare.': 'Review the highlighted information before saving.',
  'Câmpurile marcate cu * sunt obligatorii.': 'Fields marked with * are required.',
  'Identificare': 'Identification',
  'Datele de bază prin care recunoști rapid vehiculul.': 'Basic details used to identify the vehicle quickly.',
  'Număr de înmatriculare': 'Registration number',
  'Serie de șasiu (VIN)': 'Vehicle identification number (VIN)',
  'Opțional · spațiile sunt eliminate automat': 'Optional · spaces are removed automatically',
  'Între 1900 și': 'Between 1900 and',
  'Utilizare și stare': 'Use and status',
  'Informații utile pentru administrarea zilnică a flotei.': 'Useful information for day-to-day fleet management.',
  'Combustibil': 'Fuel type',
  'Kilometraj curent': 'Current mileage',
  'Se actualizează automat data kilometrajului': 'The mileage date is updated automatically',
  'Utilizare internă': 'Internal use',
  'Ex. protocol, distribuție': 'E.g. pool car, distribution',
  'Caracteristici autoturism': 'Passenger car specifications',
  'Detalii tehnice și de confort pentru evidența autoturismului.': 'Technical and comfort details for the passenger car record.',
  'Transmisie': 'Transmission',
  'Selectează transmisia': 'Select transmission',
  'Capacitate motor': 'Engine capacity',
  'Opțional · unitatea folosită de sistem': 'Optional · unit used by the system',
  'Culoare': 'Colour',
  'Capacitate și tip': 'Capacity and type',
  'Datele principale despre capacitatea de transport a dubei.': 'Key information about the van’s carrying capacity.',
  'Volum spațiu marfă': 'Cargo space volume',
  'Completează dimensiunile interioare utile, în centimetri.': 'Enter the usable interior dimensions in centimetres.',
  'Echipamente speciale': 'Special equipment',
  'Selectează toate dotările disponibile. Acest câmp este opțional.': 'Select all available equipment. This field is optional.',
  'Ai modificări nesalvate.': 'You have unsaved changes.',
  'Nu ai făcut modificări.': 'You have not made any changes.',
  'Vehiculul va fi adăugat în evidența internă.': 'The vehicle will be added to the internal fleet register.',

  // Add truck / trailer forms
  'NUMĂR ÎNMATRICULARE': 'REGISTRATION NUMBER',
  'NUMĂR VIN': 'VIN',
  'MARCĂ': 'MAKE',
  'AN FABRICAȚIE': 'YEAR OF MANUFACTURE',
  'DATA ULTIMULUI SERVICE': 'LAST SERVICE DATE',
  'Costuri profitabilitate': 'Profitability Costs',
  'RATĂ AUTOVEHICUL LUNARĂ (EUR)': 'MONTHLY VEHICLE INSTALMENT (EUR)',
  'RATĂ VALABILĂ PÂNĂ LA': 'INSTALMENT VALID UNTIL',
  'AMORTIZARE LUNARĂ (EUR)': 'MONTHLY DEPRECIATION (EUR)',
  'AMORTIZARE VALABILĂ PÂNĂ LA': 'DEPRECIATION VALID UNTIL',
  'RCA VALABIL PÂNĂ LA': 'THIRD-PARTY LIABILITY INSURANCE VALID UNTIL',
  'CASCO VALABIL PÂNĂ LA': 'COMPREHENSIVE INSURANCE VALID UNTIL',
  'ASIGURARE MARFĂ LUNARĂ (EUR)': 'MONTHLY CARGO INSURANCE (EUR)',
  'ASIGURARE MARFĂ VALABILĂ PÂNĂ LA': 'CARGO INSURANCE VALID UNTIL',
  'GREUTATE GOALĂ (kg)': 'KERB WEIGHT (kg)',
  'GREUTATE ÎNCĂRCARE (kg)': 'PAYLOAD (kg)',
  'GREUTATE TOTALĂ PERMISĂ (kg)': 'MAXIMUM PERMITTED MASS (kg)',
  'ÎNĂLȚIME (cm)': 'HEIGHT (cm)',
  'LĂȚIME (cm)': 'WIDTH (cm)',
  'NUMĂR AXE': 'NUMBER OF AXLES',
  'ÎNCĂRCARE AXĂ (kg)': 'AXLE LOAD (kg)',
  'COD RESTRICȚIE TUNEL': 'TUNNEL RESTRICTION CODE',
  'VITEZĂ MAXIMĂ (km/h)': 'MAXIMUM SPEED (km/h)',
  'CREEAZĂ CAMION': 'CREATE TRUCK',
  'TIP REMORCĂ': 'TRAILER TYPE',
  'ÎNĂLȚIME (m)': 'HEIGHT (m)',
  'LĂȚIME (m)': 'WIDTH (m)',
  'GREUTATE TOTALĂ (kg)': 'GROSS WEIGHT (kg)',
  'GREUTATE PE AXĂ (kg)': 'AXLE WEIGHT (kg)',
  'CLASĂ MĂRFURI PERICULOASE': 'DANGEROUS GOODS CLASS',
  'DESCRIERE MĂRFURI PERICULOASE': 'DANGEROUS GOODS DESCRIPTION',
  'CREEAZĂ REMORCĂ': 'CREATE TRAILER',

  // Truck details and editing
  'Ocupat': 'In use',
  'Mentenanță': 'Maintenance',
  'Greutate proprie': 'Unladen weight',
  'Gardă la sol': 'Ground clearance',
  'Greutate pe osie': 'Axle weight',
  'Osie față': 'Front axle',
  'Osii': 'Axles',
  'Axe': 'Axles',
  'Capacitate cilindrică': 'Engine displacement',
  'Data înmatriculării': 'Registration date',
  'Data inspecției tehnice': 'Roadworthiness inspection date',
  'Condiție legală': 'Legal status',
  'Condiții legale': 'Legal requirements',
  'Înmatriculare': 'Registration',
  'Inspecție': 'Inspection',
  'Taxă': 'Tax',
  'Încărcătură maximă': 'Maximum payload',
  'Încărcătură': 'Payload',
  'Trepte de viteză': 'Gears',
  'Număr trepte': 'Number of gears',
  'Viteză': 'Speed',
  'Treaptă': 'Gear',
  'Valoare': 'Value',
  'Dată': 'Date',
  'Față': 'Front',
  'Stânga': 'Left',
  'Producător': 'Manufacturer',
  'Furnizor': 'Supplier',
  'Serie șasiu (VIN)': 'Vehicle identification number (VIN)',
  'Șasiu': 'Chassis',
  'Companie': 'Company',
  'Informații service': 'Service information',
  'Ultima vizită la service': 'Last service visit',
  'Următoarea vizită la service': 'Next service visit',
  'Detalii greutate': 'Weight details',
  'Detalii dimensiuni': 'Dimensions',
  'Detalii motor': 'Engine details',
  'Detalii viteze': 'Gear details',
  'Greutate încărcare': 'Payload',
  'Sarcină axă': 'Axle load',
  'Sarcină osie': 'Axle load',
  'Sarcină pe osie': 'Axle load',
  'Clasă emisii CO2': 'CO₂ emission class',
  'Zonă emisii reduse': 'Low-emission zone',
  'Vehicul livrare': 'Delivery vehicle',
  'Vehicul de livrare': 'Delivery vehicle',
  'Cod restricție tunel': 'Tunnel restriction code',
  'documente': 'documents',
  'VIN (Șasiu)': 'VIN (Chassis)',
  'Tip vehicul / tracțiune': 'Vehicle type / drivetrain',
  'Ultima revizie': 'Last service',
  'Ultima revizie:': 'Last service:',
  'Următoarea revizie': 'Next service',
  'Rată leasing': 'Lease payment',
  'Leasing plătit până la': 'Lease paid until',
  'Amortizare avans până la': 'Advance depreciation until',
  'Amortizare plătită până la': 'Depreciation paid until',
  'Asigurări': 'Insurance',
  'Asigurări plătite până la': 'Insurance paid until',
  'Expirat la:': 'Expired on:',
  'Adăugat:': 'Added:',
  'Adaugă primul document': 'Add the first document',
  'Combustie': 'Combustion engine',
  'Vehicul motor': 'Motor vehicle',
  'Semiremorcă': 'Semi-trailer',
  '4x4 integrală': 'Four-wheel drive',
  'Tracțiune față': 'Front-wheel drive',
  'Tracțiune spate': 'Rear-wheel drive',
  'Rată până la': 'Instalment until',
  'Amortizare până la': 'Depreciation until',
  'Include rată și amortizare': 'Includes instalment and depreciation',
  'RCA până la': 'Third-party liability insurance until',
  'CASCO până la': 'Comprehensive insurance until',
  'Asigurare marfă lunară': 'Monthly cargo insurance',
  'Asigurare marfă până la': 'Cargo insurance until',
  'Codul AROBS trebuie să fie un număr întreg pozitiv.': 'The AROBS code must be a positive integer.',
  'Camionul a fost actualizat cu succes.': 'Truck updated successfully.',
  'Nu am putut actualiza camionul. Încearcă din nou.': 'Could not update the truck. Please try again.',
  'Greutăți, dimensiuni și osii': 'Weights, dimensions and axles',
  'Motor, emisii și încărcătură': 'Engine, emissions and payload',
  'Costuri fixe profitabilitate': 'Fixed profitability costs',
  'Rată autovehicul pe lună': 'Monthly vehicle instalment',
  'Rată valabilă până la': 'Instalment valid until',
  'Amortizare pe lună': 'Monthly depreciation',
  'Amortizare valabilă până la': 'Depreciation valid until',
  'RCA valabil până la': 'Third-party liability insurance valid until',
  'CASCO valabil până la': 'Comprehensive insurance valid until',
  'Asigurare marfă valabilă până la': 'Cargo insurance valid until',
  'Nicio modificare': 'No changes',
  'Service necunoscut': 'Service date unavailable',
  'Status camion': 'Truck status',
  'document expiră': 'document expiring',
  'documente expiră': 'documents expiring',
  'Vezi informații': 'View information',
  'Vezi documente': 'View documents',

  // Trailer details and editing
  'Greutate per axă': 'Weight per axle',
  'Clasă ADR': 'ADR class',
  'Descriere ADR': 'ADR description',
  'Categorie tunel': 'Tunnel category',
  'Numărul de înmatriculare este obligatoriu.': 'The registration number is required.',
  'Remorca a fost actualizată cu succes.': 'Trailer updated successfully.',
  'Nu am putut actualiza remorca. Încearcă din nou.': 'Could not update the trailer. Please try again.',
  'Editare remorcă': 'Edit trailer',
  'Dimensiuni și greutăți': 'Dimensions and weights',
  'Siguranță și emisii': 'Safety and emissions',
  'Revizie la zi': 'Service up to date',
  'Revizie în curând': 'Service due soon',
  'Revizie depășită': 'Service overdue',
  'Status remorcă': 'Trailer status',
  'Ocupată': 'In use',

  // Consolidated vehicle-cost labels
  'Rată autovehicul / lună': 'Monthly vehicle instalment',
  'Rată lunară valabilă până la': 'Monthly instalment valid until',
  'Amortizare / lună': 'Monthly depreciation',
  'Amortizare lunară până la': 'Monthly depreciation until',
  'RCA / lună': 'Monthly third-party liability insurance',
  'CASCO / lună': 'Monthly comprehensive insurance',
  'Amortizare remorcă': 'Trailer depreciation',
  'Valori fixe și lunare configurate pentru acest vehicul': 'Fixed and monthly values configured for this vehicle',

  // Remaining Fleet labels and spelling variants used by older forms
  'Titlu document *': 'Document title *',
  'Titlu document': 'Document title',
  'Titlu': 'Title',
  'Capacitate motor:': 'Engine capacity:',
  'Kilometraj': 'Mileage',
  'Kilometraj:': 'Mileage:',
  'Programat': 'Scheduled',
  'zile': 'days',
  'Deschide': 'Open',
  'Asigurare': 'Insurance',
  'asigurare': 'insurance',
  'Carte de identitate': 'Identity document',
  'Tahograf': 'Tachograph',
  'tahograf': 'tachograph',
  'Altele': 'Other',
  'altele': 'other',
  'Contract de asigurare': 'Insurance contract',
  'Carte de identitate a vehiculului': 'Vehicle identity document',
  'Carte de identitate (CIV)': 'Vehicle identity document (CIV)',
  'Critic': 'Critical',
  'Urgent': 'Urgent',
  'Emis:': 'Issued:',
  '(recomandat)': '(recommended)',
  '" are deja un document activ.': '" already has an active document.',
  'Nu ai acces la documentele vehiculului.': 'You do not have access to the vehicle documents.',
  'tipuri': 'types',
  'Copie conforma': 'Certified copy',
  'Fara expirare': 'No expiry date',
  'Fisier document (optional)': 'Document file (optional)',
  'Salveaza document': 'Save document',
  'Deschide document': 'Open document',
  'Introdu marca vehiculului.': 'Enter the vehicle make.',
  'Introdu modelul vehiculului.': 'Enter the vehicle model.',
  'Introdu kilometrajul curent.': 'Enter the current mileage.',
  'Putere': 'Power',
  'Putere (kW)': 'Power (kW)',
  'Kilometraj: mic–mare': 'Mileage: low to high',
  'Kilometraj: mare–mic': 'Mileage: high to low',
  'LUNGIME (cm)': 'LENGTH (cm)',
  'LUNGIME (m)': 'LENGTH (m)',
  'TIP COMBUSTIBIL': 'FUEL TYPE',
  'Certificate tahograf': 'Tachograph certificates',
  'Asigurare RCA': 'Third-party liability insurance (RCA)',
  'Asigurare CASCO': 'Comprehensive insurance (CASCO)',
  'Introdu numele documentului...': 'Enter the document name...',
  'Status Document': 'Document Status',
  'Cai putere': 'Horsepower',
  'Expirare asigurare': 'Insurance expiry',
  'Capacitate': 'Capacity',
  'Stare': 'Status',
  'Istoric': 'History',
  'Ultima actualizare': 'Last updated',
  'Expirare:': 'Expiry:',
  'Caută după numărul de înmatriculare...': 'Search by registration number...',
  'Căutare': 'Search',
  'Permis de conducere': 'Driving licence',
  'Atestat profesional': 'Professional qualification certificate',
  'Aviz psihologic': 'Psychological fitness certificate',
  'Formular A1/Portable Document A1 (UE)': 'A1 Form / Portable Document A1 (EU)',
  'Ex: Auto Service SRL': 'E.g. Auto Service Ltd',
  'Nu este specificat': 'Not specified',
  'Expira azi': 'Expires today',
  'Expira in': 'Expires in',
  'Selecteaza data': 'Select a date',
  'Inchide': 'Close',
  'Selecteaza categoria': 'Select category',
  'Inlocuieste fisierul (optional)': 'Replace file (optional)',
  'Pastreaza fisierul existent': 'Keep the existing file',
  'Lasa gol ca sa pastrezi fisierul actual.': 'Leave blank to keep the current file.',
  'Se salveaza...': 'Saving...',
  'Salveaza modificari': 'Save changes',
  '| Expira:': '| Expires:',
  'Fara fisier': 'No file',
  'Documentele flotei': 'Fleet Documents',
  'Categorii de vehicule': 'Vehicle categories',
  'Lista documentelor': 'Document list',
  'Durata (ore)': 'Duration (hours)',
  'Durata:': 'Duration:',
  'ore': 'hours',
  'Km la intrare': 'Entry mileage',
  'Km la Intrare:': 'Entry Mileage:',
  'Programate': 'Scheduled',
  'Filtre': 'Filters',
  'Filtre:': 'Filters:',
  'Cele mai recente': 'Newest first',
  'Cele mai vechi': 'Oldest first',
  'An: cele mai noi': 'Year: newest first',
  'An: cele mai vechi': 'Year: oldest first',
  'RCA LUNAR (EUR)': 'MONTHLY THIRD-PARTY LIABILITY INSURANCE (EUR)',
  'CASCO LUNAR (EUR)': 'MONTHLY COMPREHENSIVE INSURANCE (EUR)',
  'Dimensiuni (cm)': 'Dimensions (cm)',
  'TIP MOTOR': 'ENGINE TYPE',
  'CATEGORIA TUNEL': 'TUNNEL CATEGORY',
  'Numele documentului este obligatoriu': 'The document name is required',
  'Categoria documentului este obligatorie': 'The document category is required',
  'Numele documentului *': 'Document name *',
  'Categoria documentului *': 'Document category *',
  'Dimensiuni': 'Dimensions',
  'Standard emisii': 'Emission standard',
  'Motor': 'Engine',
  'Liber': 'Available',
  'Amortizare avans': 'Advance depreciation',
  'Pasageri': 'Passengers',
  'Mixt': 'Mixed use',
  'Cod Arobs': 'AROBS code',
  'RCA lunar': 'Monthly third-party liability insurance',
  'CASCO lunar': 'Monthly comprehensive insurance',
  'Neinregistrat': 'Not recorded',
  'Titlul documentului': 'Document title',
  'Categoria': 'Category',
  'Tip emisii': 'Emission type',
  'Locuri': 'Seats',
  'Categoria tunel': 'Tunnel category',
  'Transport pentru profitabilitate': 'Linked transport for profitability',
  'Anulare': 'Cancel',
  'Disponibilitate:': 'Availability:',
  'Transport asociat:': 'Linked transport:',
  'Fotografie': 'Photo',
  'Finalizate': 'Completed',
  'Cost (desc)': 'Cost (descending)',
  'Cost (asc)': 'Cost (ascending)',
  'din': 'of',
  'rezultate': 'results',
  'Cost Mediu': 'Average Cost',
  'Doar expirate': 'Expired only',
  'Greutate': 'Weight',
  'Viteze': 'Gears',
  '• An': '• Year',
  'EDITARE': 'EDIT',
  'Inspectii tehnice periodice': 'Periodic roadworthiness inspections',
  'Procedura de instalare': 'Installation procedure',
  'Ex. Albastru': 'E.g. Blue',
  'Valabil': 'Valid',
  'Hibrid': 'Hybrid',

  // Fleet status metadata and AROBS synchronisation
  'Medie': 'Average',
  'Nesincronizat': 'Not synchronised',
  'Sincronizat': 'Synchronised',
  'Atestat': 'Professional qualification certificate',
  'Livrat': 'Delivered',
  'Avertizare': 'Warning',
});

// Dynamic messages emitted as template literals cannot be represented by exact
// lookup entries. Consumers should append these patterns after the shared legacy
// patterns and apply the first matching rule.
export const legacyEnglishFleetPatterns = Object.freeze([
  [/^Pentru (.+)$/u, 'For $1'],
  [
    /^([0-9]+(?:[.,][0-9]+)?) EUR\/zi · curs ([0-9]+(?:[.,][0-9]+)?)$/u,
    '$1 EUR/day · exchange rate $2',
  ],
  [
    /^(.+) ora$/u,
    (_, label) => ({
      'Data intrare service': 'Service start time',
      'Data ieșire service': 'Service end time',
    }[label] || `${label} time`),
  ],
  [
    /^(\d+) (autoturism|autoturisme|dubă|dube) (găsit|găsită|găsite|în flotă)$/,
    (_, count, vehicle, result) => {
      const nouns = {
        autoturism: 'passenger car',
        autoturisme: 'passenger cars',
        dubă: 'van',
        dube: 'vans',
      };
      return `${count} ${nouns[vehicle]} ${result === 'în flotă' ? 'in fleet' : 'found'}`;
    },
  ],
  [/^Nu s-a găsit niciun camion pentru „(.+)”\.$/, 'No truck was found for “$1”.'],
  [/^Nu s-a găsit nicio remorcă pentru „(.+)”\.$/, 'No trailer was found for “$1”.'],
  [/^Nu s-a găsit niciun camion cu numărul de înmatriculare "(.+)"\.$/, 'No truck was found with registration number "$1".'],
  [/^Nu s-a găsit nicio remorcă cu numărul de înmatriculare "(.+)"\.$/, 'No trailer was found with registration number "$1".'],
  [/^Ești sigur că dorești să ștergi camionul (.+)\?$/, 'Are you sure you want to delete truck $1?'],
  [/^Ești sigur că dorești să ștergi remorca (.+)\?$/, 'Are you sure you want to delete trailer $1?'],
  [/^Nu am putut încărca lista de (autoturisme|dube)\.$/, (_, noun) => `Could not load the list of ${noun === 'dube' ? 'vans' : 'passenger cars'}.`],
  [/^Nu am putut încărca (autoturism|dubă)\.$/, (_, noun) => `Could not load the ${noun === 'dubă' ? 'van' : 'passenger car'}.`],
  [/^Nu am putut salva (autoturism|dubă)\.$/, (_, noun) => `Could not save the ${noun === 'dubă' ? 'van' : 'passenger car'}.`],
  [/^Nu am putut șterge (autoturism|dubă)\.$/, (_, noun) => `Could not delete the ${noun === 'dubă' ? 'van' : 'passenger car'}.`],
  [/^Nu am putut încărca detaliile pentru (autoturism|dubă)\.$/, (_, noun) => `Could not load the ${noun === 'dubă' ? 'van' : 'passenger car'} details.`],
  [/^Nu există (autoturisme|dube)$/, (_, noun) => `No ${noun === 'dube' ? 'vans' : 'passenger cars'}`],
  [/^Adaugă primul (autoturism|dubă) pentru a începe evidența\.$/, (_, noun) => `Add the first ${noun === 'dubă' ? 'van' : 'passenger car'} to start your records.`],
  [
    /^(Adaugă|Editează|Șterge|Da, șterge) (autoturism|dubă)$/,
    (_, action, noun) => {
      const actions = { Adaugă: 'Add', Editează: 'Edit', Șterge: 'Delete', 'Da, șterge': 'Yes, delete' };
      return `${actions[action]} ${noun === 'dubă' ? 'van' : 'passenger car'}`;
    },
  ],
  [/^Anul trebuie să fie între 1900 și (\d{4})\.$/, 'The year must be between 1900 and $1.'],
  [/^Între 1900 și (\d{4})$/, 'Between 1900 and $1'],
  [/^Sigur vrei să ștergi documentul "(.+)"\?$/, 'Are you sure you want to delete document "$1"?'],
  [/^Sigur vrei sa stergi documentul "(.+)"\?$/, 'Are you sure you want to delete document "$1"?'],
  [/^Ștergi documentul "(.+)"\? Dacă este valid, următorul document devine automat activ\.$/, 'Delete document "$1"? If it is valid, the next document will automatically become active.'],
  [/^Nu s-a putut efectua editarea\. Categoria "(.+)" are deja un document activ\.$/, 'The document could not be updated. Category "$1" already has an active document.'],
  [/^Șterge (.+)$/, 'Delete $1'],
  [/^Editeaza (.+)$/, 'Edit $1'],
  [/^Expirat de (\d+) (zi|zile)$/, (_, count) => `Expired ${count} ${Number(count) === 1 ? 'day' : 'days'} ago`],
  [/^Expiră în (\d+) (zi|zile)$/, (_, count) => `Expires in ${count} ${Number(count) === 1 ? 'day' : 'days'}`],
  [/^Expira in (\d+) zile$/, (_, count) => `Expires in ${count} ${Number(count) === 1 ? 'day' : 'days'}`],
  [/^Expirat la: (.+)$/, 'Expired on: $1'],
  [/^Expiră la: (.+)$/, 'Expires on: $1'],
  [/^Întârziat (\d+) zile$/, (_, count) => `${count} days overdue`],
  [/^În (\d+) zile$/, (_, count) => `In ${count} days`],
  [/^(\d+) document expiră$/, '$1 document expiring'],
  [/^(\d+) documente expiră$/, '$1 documents expiring'],
  [/^Camion #(\S+)$/, 'Truck #$1'],
  [/^Salvează \((\d+)\)$/, 'Save ($1)'],
  [
    /^(?=[\s\S]*<title>Raport Intervenții<\/title>)[\s\S]*$/,
    (html) => html
      .replaceAll('<title>Raport Intervenții</title>', '<title>Intervention Report</title>')
      .replaceAll('<h1>Raport Intervenții</h1>', '<h1>Intervention Report</h1>')
      .replaceAll('<span class="tag">Perioadă:', '<span class="tag">Period:')
      .replaceAll('<span class="tag">Total intervenții:', '<span class="tag">Total interventions:')
      .replaceAll('<span class="tag">Cost total:', '<span class="tag">Total cost:')
      .replaceAll('<h2>Top vehicule după cost</h2>', '<h2>Top vehicles by cost</h2>')
      .replaceAll('<h2>Intervenții</h2>', '<h2>Interventions</h2>')
      .replaceAll('<th>Nr. intervenții</th>', '<th>No. of interventions</th>')
      .replaceAll('<th>Referință</th>', '<th>Reference</th>')
      .replaceAll('<th>Vehicul</th>', '<th>Vehicle</th>')
      .replaceAll('<th>Intrare</th>', '<th>Entry</th>')
      .replaceAll('<th>Cost total</th>', '<th>Total cost</th>')
      .replaceAll('<th>Tip</th>', '<th>Type</th>'),
  ],
]);
